import { gql } from "@apollo/client";

const UPDATE_PASSWORD = gql`
    mutation UpdatePassword($password: String!) {
        editarCuenta(input: {
            password: $password
        }) {
            cuenta {
                id
            }
            errores {
                mensaje
                codigo
                ruta
                pista
            }
        }
    }
`;

export default UPDATE_PASSWORD;
